import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GallaryComponent } from './gallary.component';
import { HttpClient } from '@angular/common/http';
import { AccordionModule } from '../accordion/accordion.module';
import { FormsModule } from '@angular/forms';
import{  NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown'
import { RouterModule } from '@angular/router';
import { ImagegridModule } from "../imagegrid/imagegrid.module";

@NgModule({
    declarations: [
        GallaryComponent
    ],
    providers: [HttpClient],
    imports: [
        CommonModule,
        FormsModule,
        AccordionModule,
        RouterModule,
        ImagegridModule
    ]
})
export class GallaryModule { }
